import React from 'react';
import { Stack, StackItem } from '@fluentui/react';
import { observer } from 'mobx-react';
import { makeAutoObservable } from 'mobx';
import SearchCtrl, { SearchCtrlStyle } from './SearchCtrl';
import DocumentSearchScopeSelector, {
	DocumentSearchScopeSelectorState,
	DocumentSearchScopeSelectorStyle,
} from './documents/DocumentSearchScopeSelector';
import { IDocumentSearchScope, IUserConfigPackage } from '../../API';
import { CombinedSearchResultsState } from './CombinedSearchResults';

export interface ICombinedSearchCtrlProps {
	state: CombinedSearchCtrlState;
	style: SearchCtrlStyle;
	placeholder: string;
}

class CombinedSearchCtrl extends React.Component<ICombinedSearchCtrlProps> {
	render() {
		return (
			<Stack horizontal>
				<StackItem grow>
					<SearchCtrl
						style={this.props.style}
						placeholder={this.props.placeholder}
						onSearchTextChanged={(searchText: string) => {
							this.props.state.setSearchText(searchText);
						}}
					/>
				</StackItem>
				<StackItem>
					<div style={{ marginTop: 5 }}>
						<DocumentSearchScopeSelector
							style={DocumentSearchScopeSelectorStyle.Dropdown}
							state={this.props.state.scope}
						/>
					</div>
				</StackItem>
			</Stack>
		);
	}
}

export default observer(CombinedSearchCtrl);

export class CombinedSearchCtrlState {
	public scope: DocumentSearchScopeSelectorState;
	results: CombinedSearchResultsState;

	constructor(
		userConfig: IUserConfigPackage,
		results: CombinedSearchResultsState,
	) {
		makeAutoObservable(this);

		this.scope = new DocumentSearchScopeSelectorState(
			userConfig,
			this.setSearchScope.bind(this),
		);
		this.results = results;
	}

	public scopeId: string = '';
	public setSearchScope(scope?: IDocumentSearchScope) {
		this.scopeId = scope?.Id || '';
		this.results.documents.setSearchScope(this.scopeId);
	}

	public searchText: string = '';
	public setSearchText(text: string) {
		this.searchText = text;
		this.results.documents.setSearchText(text);
	}
}
